/**
 * Olara wishlist: localStorage + /products/{handle}.json
 */
(function () {
  var STORAGE_KEY = 'olara_wishlist_v1';

  function getHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr)
        ? arr.filter(function (h) {
            return typeof h === 'string' && h.length;
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  function setHandles(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    window.dispatchEvent(
      new CustomEvent('olara:wishlist-changed', { detail: { handles: handles.slice() } })
    );
  }

  function isInWishlist(handle) {
    return getHandles().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var handles = getHandles().slice();
    var i = handles.indexOf(handle);
    if (i === -1) handles.unshift(handle);
    else handles.splice(i, 1);
    setHandles(handles);
    return i === -1;
  }

  function moneyFormat() {
    var b = document.body;
    return b ? b.getAttribute('data-money-format') || '${{amount}}' : '${{amount}}';
  }

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, moneyFormat());
      } catch (e) {}
    }
    return (cents / 100).toFixed(2);
  }

  function syncButtons() {
    document.querySelectorAll('[data-olara-wishlist]').forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      if (!h) return;
      var on = isInWishlist(h);
      btn.classList.toggle('is-wishlisted', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-olara-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggle(handle);
    syncButtons();
  });

  onReady(syncButtons);
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) syncButtons();
  });

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function renderWishlistPage(root) {
    var emptyEl = root.querySelector('[data-wishlist-empty]');
    var gridEl = root.querySelector('[data-wishlist-grid]');
    var loadEl = root.querySelector('[data-wishlist-loading]');
    if (!gridEl || !emptyEl) return;

    function setVisible(el, on) {
      if (el) el.hidden = !on;
    }

    function run() {
      var handles = getHandles();
      if (handles.length === 0) {
        setVisible(loadEl, false);
        setVisible(emptyEl, true);
        gridEl.innerHTML = '';
        gridEl.hidden = true;
        return;
      }

      setVisible(emptyEl, false);
      setVisible(loadEl, true);
      gridEl.hidden = true;
      gridEl.innerHTML = '';

      var shopUrl = root.getAttribute('data-shop-url') || '';
      var removeLabel = root.getAttribute('data-remove-label') || 'Remove';
      var addToCartLabel = root.getAttribute('data-add-to-cart-label') || 'Add to cart';
      var oosCtaLabel = root.getAttribute('data-oos-cta-label') || 'Out of stock';
      var oosNotifyEnabled = root.getAttribute('data-oos-notify-enabled') === 'true';

      Promise.all(
        handles.map(function (handle) {
          return fetch(shopUrl + '/products/' + encodeURIComponent(handle) + '.js')
            .then(function (r) {
              if (!r.ok) return null;
              return r.json();
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (products) {
        setVisible(loadEl, false);
        gridEl.hidden = false;
        var frag = document.createDocumentFragment();
        products.forEach(function (p) {
          if (!p || !p.handle) return;
          var img =
            p.featured_image ||
            (p.images && p.images.length ? p.images[0] : '') ||
            '';
          var price = p.price_min != null ? p.price_min : p.price;
          var productPath = p.url || '/products/' + p.handle;
          var available = p.available !== false;
          var ctaHtml;
          if (available) {
            ctaHtml =
              '<a class="product-card-modern__button" href="' +
              escapeHtml(productPath) +
              '">' +
              escapeHtml(addToCartLabel) +
              '</a>';
          } else if (oosNotifyEnabled) {
            ctaHtml =
              '<button type="button" class="product-card-modern__button product-card-modern__button--oos-notify" data-collection-oos-notify data-oos-product-url="' +
              escapeHtml(productPath) +
              '" data-oos-product-title="' +
              escapeHtml(p.title || '') +
              '">' +
              escapeHtml(oosCtaLabel) +
              '</button>';
          } else {
            ctaHtml =
              '<a class="product-card-modern__button product-card-modern__button--oos-notify" href="' +
              escapeHtml(productPath) +
              '">' +
              escapeHtml(oosCtaLabel) +
              '</a>';
          }
          var card = document.createElement('article');
          card.className = 'main-wishlist__card';
          card.innerHTML =
            '<div class="main-wishlist__card-inner">' +
            '<a class="main-wishlist__link" href="' +
            escapeHtml(productPath) +
            '">' +
            (img
              ? '<div class="main-wishlist__media"><img src="' +
                escapeHtml(img) +
                '" alt="' +
                escapeHtml(p.title || '') +
                '" loading="lazy" width="220" height="220"></div>'
              : '') +
            '<h2 class="main-wishlist__title">' +
            escapeHtml(p.title || '') +
            '</h2>' +
            '<p class="main-wishlist__price">' +
            escapeHtml(formatMoney(price)) +
            '</p>' +
            '</a>' +
            '<div class="main-wishlist__cta" onclick="event.stopPropagation();">' +
            ctaHtml +
            '</div>' +
            '<button type="button" class="main-wishlist__remove" data-olara-wishlist data-product-handle="' +
            escapeHtml(p.handle) +
            '">' +
            escapeHtml(removeLabel) +
            '</button>' +
            '</div>';
          frag.appendChild(card);
        });
        gridEl.appendChild(frag);
        syncButtons();
      });
    }

    run();
    window.addEventListener('olara:wishlist-changed', run);
  }

  onReady(function () {
    var root = document.querySelector('[data-olara-wishlist-page]');
    if (root) renderWishlistPage(root);
  });

  window.OlaraWishlist = {
    getHandles: getHandles,
    syncButtons: syncButtons,
    STORAGE_KEY: STORAGE_KEY,
  };
})();
